import { jsx as _jsx } from "react/jsx-runtime";
import { classNameFactory } from "@src/utils/dom";
import "./separator.scss";
const cn = classNameFactory("separator");
export const Separator = () => _jsx("div", { className: cn("") });
